import React from 'react';
import { LockedIcon } from '../status-icons/LockedIcon';
import { CheckmarkIcon } from '../status-icons/CheckmarkIcon';

const VideoStatus = (props) => {
  const {
    assignment,
    isComplete = false,
    submitted = 0,
    totalSubmissions = 0,
    isUnassigned = false,
  } = props;
  const { status, progress = {}, starts_at, due_at } = assignment || {};

  const renderText = (text) => (
    <span className="mb-0 text-gray-600 text-12">{text}</span>
  );

  const hasStudents = progress.total_students && progress.total_students > 0;
  const isPastOrFuture =
    status === 'locked' || status === 'closed' || (!starts_at && !due_at);
  const isMarkedComplete = status === 'completed';
  const consideredComplete = isMarkedComplete || isComplete;

  if (!isUnassigned && !hasStudents) {
    if (isPastOrFuture) {
      return renderText('Locked');
    } else if (status === 'open') {
      return renderText('Assigned');
    }
  }

  const submittedPercent =
    (totalSubmissions && Math.round((submitted * 100) / totalSubmissions)) || 0;
  const renderSubmitted = (
    <div>
      <div>{renderText(`${submittedPercent}% Watched`)}</div>
    </div>
  );

  const renderLockedAssignment = (
    <div className="flex items-center">
      <LockedIcon className="mr-1" />
    </div>
  );

  const renderCompletedAssignment = (
    <div className="flex items-center">
      <CheckmarkIcon className="mr-1" />
      {renderText('Complete')}
    </div>
  );
  let renderedStatus;

  if (consideredComplete) {
    renderedStatus = renderCompletedAssignment;
  } else if (isPastOrFuture) {
    renderedStatus = (
      <div className="flex flex-row -ml-1 items-center">
        {renderLockedAssignment}
        {renderSubmitted}
      </div>
    );
  } else {
    renderedStatus = renderSubmitted;
  }

  if (isUnassigned && !consideredComplete) {
    renderedStatus = (
      <div className="flex flex-row -ml-1 items-center">
        {renderText('Unassigned')}
      </div>
    );
  }

  return renderedStatus;
};

export default VideoStatus;
